module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-carry-in-image-3fc9f70bcb9ed130f545341c7f12db92.png";